import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import {
  buildUpgradeRouteFromInput,
  type UpgradeOpenInput,
  type UpgradeOpenOverrides,
} from '../lib/upgrade-routing';

/**
 * Opens the canonical paywall from a route presented as an iOS formSheet.
 *
 * A normal push stacks one native sheet over another. Dismissing the paywall
 * can then leave the first sheet's transparent presentation layer alive and
 * swallowing every touch. Expo Router's dismissTo is atomic here: when the
 * paywall is not already in the stack it replaces the current formSheet route,
 * so there is never a second native presentation above it and no delay/timer.
 */
export function useUpgradeFromFormSheet() {
  const router = useRouter();

  return useCallback(
    (input?: UpgradeOpenInput, overrides?: UpgradeOpenOverrides) => {
      router.dismissTo(buildUpgradeRouteFromInput(input, overrides));
    },
    [router],
  );
}
